import { theme as baseTheme } from '~/design-system';
// We're not using gatsby-shared yet.
// import { theme as sharedTheme } from '@bottlebooks/gatsby-shared';

const theme = baseTheme;
/* Alternative: */
// const theme = {
//   ...baseTheme,
//   ...sharedTheme,
// };

export default theme;
